// extracted by mini-css-extract-plugin
module.exports = {"disc":"e_Al","accent":"e_Bl","empty":"e_Cl","s32":"e_Dl","s36":"e_El","s44":"e_Fl","s56":"e_Gl","s72":"e_Hl"};